import { render, staticRenderFns } from "./AttentionQuestion.vue?vue&type=template&id=6f591273"
import script from "./AttentionQuestion.vue?vue&type=script&lang=js"
export * from "./AttentionQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports